export default function getAddressFromLocation(location) {
  return new Promise(function(resolve) {
    const geocoder = new google.maps.Geocoder
    geocoder.geocode({ 'location': location }, function(results, status) {
      if (status === 'OK' && results[0]) resolve(results[0].formatted_address)
      else resolve(null)
    })
  })
}



// WEBPACK FOOTER //
// ./src/helpers/map/getAddressFromLocation.js